import { api, env } from "../services/api.js";

// Fetch and display jobs from API
document.addEventListener("DOMContentLoaded", () => {
    const jobList = document.getElementById("jobList");
    const form = document.getElementById("jobSearchForm");
    const roleInput = document.getElementById("jobRole");
    const categoryInput = document.getElementById("jobCategory");

    if (!jobList) return;

    function fetchDropdownOptions() {
        if (roleInput) {
            api.get("jobs/roles").then(response => {
                if (response && !response.error && response.data && Array.isArray(response.data.items)) {
                    response.data.items.forEach(role => {
                        const opt = document.createElement("option");
                        opt.value = role;
                        opt.textContent = role;
                        roleInput.appendChild(opt);
                    });
                }
            }).catch(err => console.error("Error fetching roles:", err));
        }

        if (categoryInput) {
            api.get("jobs/locations").then(response => {
                if (response && !response.error && response.data && Array.isArray(response.data.items)) {
                    response.data.items.forEach(loc => {
                        const opt = document.createElement("option");
                        opt.value = loc;
                        opt.textContent = loc;
                        categoryInput.appendChild(opt);
                    });
                }
            }).catch(err => console.error("Error fetching locations:", err));
        }
    }
    
    fetchDropdownOptions();

    function fetchJobs(role = "", category = "") {
        const payload = {
            limit: 10,
            orderBy: "updatedAt",
            orderDirection: "DESC",
            page: 1,
            search: {}
        };

        if (role) {
            payload.search.jobRole = role;
        }
        if (category) {
            payload.search.locations = category;
        }

        api.post("jobs/list", payload)
            .then(response => {
                if (response && !response.error && response.data && Array.isArray(response.data.items) && response.data.items.length > 0) {
                    let records = response.data.items[0].records || [];
                    records = records.filter(job => job.isActive !== false);
                    renderJobs(records);
                } else {
                    renderJobs([]);
                }
            })
            .catch(err => {
                console.error("Error fetching jobs:", err);
                renderJobs([]);
            });
    }

    // Handle search
    if (form) {
        form.addEventListener("submit", (e) => {
            e.preventDefault();
            const role = roleInput ? roleInput.value : "";
            const category = categoryInput ? categoryInput.value : "";
            fetchJobs(role, category);
        });
        
        const clearBtn = document.getElementById("clearFiltersBtn");
        if (clearBtn) {
            clearBtn.addEventListener("click", () => {
                if (roleInput) roleInput.value = "";
                if (categoryInput) categoryInput.value = "";
                fetchJobs(); // Fetch all jobs without filters
            });
        }
    }

    // Initial fetch
    fetchJobs();

    // Render jobs into DOM
    function renderJobs(jobs) {
        jobList.innerHTML = "";

        if (!jobs || jobs.length === 0) {
            jobList.innerHTML = `
                <div class="no_jobs text-center">
                    <h2 style="font-size: 1.5rem; margin-bottom: 0.5rem; font-weight: 500;">Currently, there are no active job openings.</h2>
                    <p>You may also send your CV to</p>
                    <p><a href="mailto:hr_operations@cognospace.in" class="mail_link">hr_operations@cognospace.in</a></p>
                    <p>for future opportunities.</p>
                </div>`;
            return;
        }

        jobs.forEach((job) => {
            const card = document.createElement("div");
            card.classList.add("job-card", "mt-4", "me-auto");
            let desc = job.description || "";
            if (desc.length > 180) {
                desc = desc.substring(0, 180).trim() + "...";
            }
            const locationStr = (job.location && Array.isArray(job.location)) ? job.location.join(", ") : (job.location || 'Not Specified');
            const detailsHref = env === 'prod'
                ? `/job-details?id=${encodeURIComponent(job.jobId)}`
                : `job-details.html?id=${encodeURIComponent(job.jobId)}`;
            
            card.innerHTML = `
                <h4>${job.jobRole}</h4>
                <p class="mb-2" style="color: #6c757d; font-size: 0.95rem;">
                    <i class="fa-solid fa-location-dot me-1"></i> ${locationStr}
                </p>
                <p>${desc} <a href="${detailsHref}" class="job-read-more" data-job-id="${job.jobId}" style="color: #FFA500; text-decoration: underline; margin-left: 5px;">Read More</a></p>
                <div class="text-end mt-2">
                    <button class="apply-btn" data-bs-toggle="modal" data-bs-target="#applyJobModal" data-job-role="${job.jobRole}" data-job-id="${job.jobId}">Apply now</button>
                </div>
            `;
            jobList.appendChild(card);
        });

        // Store selected job ID when user clicks Read More
        document.querySelectorAll('.job-read-more').forEach(link => {
            link.addEventListener('click', function() {
                const jId = this.getAttribute('data-job-id');
                if (jId) {
                    try { sessionStorage.setItem('selectedJobId', jId); } catch (e) {}
                }
            });
        });

        // Add listener to update modal title dynamically
        document.querySelectorAll('.apply-btn').forEach(btn => {
            btn.addEventListener('click', function() {
                const role = this.getAttribute('data-job-role');
                const jId = this.getAttribute('data-job-id');
                const modalTitle = document.querySelector('#applyJobModal .modal-title .text-orange');
                if (modalTitle && role) {
                    modalTitle.textContent = role;
                }
                const hiddenJobId = document.getElementById('appJobId');
                if (hiddenJobId && jId) {
                    hiddenJobId.value = jId;
                }
            });
        });
    }
});

